import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, ComboBox, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EditLocationModal = ({
  show,
  title,
  headerMessage,
  currentLocation,
  locations,
  saving,
  onClose,
  onSave,
  warningComponent,
}) => {
  const { t } = useTranslation()
  const [newLocation, setNewLocation] = useState(null)

  useEffect(() => {
    if (show) {
      setNewLocation(null)
    }
  }, [show])

  const handleSave = () => {
    onSave(newLocation)
  }

  const handleChangeLocation = e => {
    const location = locations.find(l => l.id === e.target.value)
    setNewLocation(location)
  }

  const showRegionWarning =
    newLocation && newLocation?.address?.country?.region_id !== currentLocation?.address?.country?.region_id

  return (
    <Modal title={title} show={show} size="l" onClose={onClose}>
      <Styles.MainContainer>
        <Text type="bodyMRegular">{headerMessage}</Text>
        <Styles.SectionContainer>
          <ComboBox
            value={newLocation}
            handleChange={handleChangeLocation}
            label={t('Ubicación')}
            menuItems={locations?.map(l => ({ label: `${l.internal_id} | ${l.internal_name}`, value: l.id })) || []}
          />
          {showRegionWarning && (
            <Alert type="warning">
              {t(
                'La nueva ubicación se encuentra en una región diferente y esto puede afectar a los costes de aduana del envío.'
              )}
            </Alert>
          )}
          {warningComponent}
        </Styles.SectionContainer>
        <Styles.ActionsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Guardar')}
            loadingLabel={t('Guardando')}
            loading={saving}
            disabled={saving || !newLocation}
            onClick={handleSave}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default EditLocationModal
